module.exports = __webpack_public_path__ + "img/mountain_land.be5030ca.webp";